@if (state?.loading || state?.error || rows.length > 0) {
<div class="pt-3">
  <h5 class="header-title mb-0">{{ 'attendance.panelList.messages.title' | translate }}</h5>
  <small class="text-muted d-block mb-2">{{ 'attendance.panelList.messages.windowHint' | translate:{ months: state.windowMonths } }}</small>

  @if (state.error) {
  <div class="alert alert-warning py-2 mb-2" role="alert">
    <p class="mb-1">{{ 'attendance.panelList.messages.unavailable' | translate }}</p>
    <button type="button" class="btn btn-sm btn-soft-primary" (click)="retry.emit()">
      {{ 'attendance.panelList.messages.retry' | translate }}
    </button>
  </div>
  }

  <div class="list-group list-group-flush">
    @for (row of rows; track row.hit.messageId) {
    <a href="javascript:void(0);" class="list-group-item list-group-item-action px-1 py-2" (click)="select.emit(row.hit)">
      <div class="d-flex justify-content-between align-items-center gap-2">
        <span class="fw-bold text-truncate" [matTooltip]="(row.hit.contact?.name ?? '') + ' - ' + getMaskedPhone(row.hit.contact?.phone ?? '')"
          [matTooltipPosition]="'above'" [matTooltipShowDelay]="1200">
          {{ $safeNavigationMigration(row.hit.contact?.name) | truncate: 22 }}
        </span>
        <small class="text-muted text-nowrap">
          {{ row.hit.sentAt | timezoneDate: 'DD/MM/YY HH:mm': getTimezoneCompanyCurrentUser() }}
        </small>
      </div>
      <p class="mb-0 text-muted font-13 text-truncate">
        <span class="badge campaign-badge is-neutral me-1">
          {{ (row.hit.direction === 'CUSTOMER' ? 'attendance.panelList.messages.fromCustomer' : 'attendance.panelList.messages.fromCompany') | translate }}
        </span>
        @if (row.icon) {
        <i [ngClass]="row.icon" class="me-1"></i>
        }
        @for (segment of row.segments; track $index) {
        @if (segment.match) {
        <mark>{{ segment.text }}</mark>
        } @else {
        <span>{{ segment.text }}</span>
        }
        }
      </p>
    </a>
    }
  </div>

  @if (state.loading) {
  <div class="d-flex justify-content-center py-2">
    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
  </div>
  } @else if (state.hasMore) {
  <button type="button" class="btn btn-soft-primary rounded-pill d-flex m-auto mt-2 gap-1" (click)="loadMore.emit()">
    <i class="ri-add-line"></i>
    <strong>{{ 'attendance.panelList.loadMore' | translate }}</strong>
  </button>
  }
</div>
}
